import { jsx, jsxs } from 'react/jsx-runtime';
import { Skeleton, SkeletonTypes } from '@promo-platform/skeleton';

const SkeletonBlock = ({ amount = 1 }) => {
    const blocksQuantityArray = Array.from(Array(amount).keys());
    return (jsx("section", Object.assign({ className: "skeleton-block-container" }, { children: blocksQuantityArray.map((item) => (jsxs("div", Object.assign({ "data-testid": "skeleton-block", className: "skeleton-block" }, { children: [jsx(Skeleton, { type: SkeletonTypes.Subtitle }), jsx(Skeleton, { type: SkeletonTypes.Text, lines: 2 }), jsx(Skeleton, { type: SkeletonTypes.Input })] }), item))) })));
};

export { SkeletonBlock };
